const LOCAL_MODES = new Set(['development', 'dev', 'local', 'test'])

function normalizeMode(mode: string | undefined): string {
  return (mode || 'development').trim().toLowerCase()
}

function isLocalMode(mode: string | undefined): boolean {
  return LOCAL_MODES.has(normalizeMode(mode))
}

function stripTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '')
}

function validateAbsoluteHttpUrl(value: string): void {
  let parsed: URL

  try {
    parsed = new URL(value)
  } catch {
    throw new Error(
      `VITE_API_BASE_URL must be a valid absolute http or https URL, received "${value}".`,
    )
  }

  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    throw new Error(
      `VITE_API_BASE_URL must use http or https, received "${value}".`,
    )
  }
}

function validateEnvironmentHost(value: string, mode: string | undefined): void {
  if (isLocalMode(mode)) {
    return
  }

  const hostname = new URL(value).hostname.toLowerCase()

  if (
    hostname === 'localhost' ||
    hostname.endsWith('.localhost') ||
    hostname === '127.0.0.1' ||
    hostname === '0.0.0.0' ||
    hostname === '[::1]'
  ) {
    throw new Error(
      `VITE_API_BASE_URL must not point to a local-only host when mode=${normalizeMode(mode)}.`,
    )
  }
}

export function resolveApiBaseUrl(rawValue: string | undefined, mode: string | undefined): string {
  const trimmedValue = rawValue?.trim()

  if (!trimmedValue) {
    if (isLocalMode(mode)) {
      throw new Error(
        `VITE_API_BASE_URL must be set when mode=${normalizeMode(mode)}. ` +
          'Set it in a local env file or prefix the dev command with VITE_API_BASE_URL=<backend-url>.',
      )
    }

    throw new Error(
      `VITE_API_BASE_URL must be set when mode=${normalizeMode(mode)}. ` +
        'It must match the backend PUBLIC_BASE_URL for the same environment.',
    )
  }

  validateAbsoluteHttpUrl(trimmedValue)
  validateEnvironmentHost(trimmedValue, mode)

  return stripTrailingSlash(trimmedValue)
}
